import { Box, Button, Typography } from '@mui/material'

import { useAuth } from 'src/auth'
import {
  getImpersonation,
  impersonationRoleLabel,
  stopImpersonation,
} from 'src/lib/impersonation'

const ImpersonationBanner = () => {
  const { currentUser } = useAuth()
  const impersonation = getImpersonation(currentUser)

  if (!impersonation?.isImpersonating) {
    return null
  }

  const impersonatedName = currentUser
    ? `${currentUser.firstName} ${currentUser.lastName}`.trim()
    : ''
  const roleLabel = impersonationRoleLabel(currentUser?.roles)

  const handleReturn = () => {
    const impersonatedUserId = currentUser?.id
    stopImpersonation(
      impersonatedUserId ? `/admin/users/${impersonatedUserId}` : '/admin/welcome'
    )
  }

  return (
    <Box
      role="status"
      sx={{
        position: 'sticky',
        top: 50,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        px: 2,
        py: 1.25,
        bgcolor: '#F59E0B',
        color: '#1A202C',
        borderBottom: '1px solid #D97706',
      }}
    >
      <Typography sx={{ fontWeight: 600 }}>
        {`Du agerar som ${impersonatedName || currentUser?.username} (${currentUser?.username}) — ${roleLabel}`}
      </Typography>
      <Button
        variant="contained"
        onClick={handleReturn}
        sx={{
          bgcolor: '#1A202C',
          color: 'white',
          '&:hover': { bgcolor: '#2D3748' },
        }}
      >
        Tillbaka till Admin
      </Button>
    </Box>
  )
}

export default ImpersonationBanner
